document.addEventListener('DOMContentLoaded', function () {
  function toggleActiveAttributeAndChangeImageSrc(swatch) {
    const swatchItems = swatch.closest('.swatches').querySelectorAll('.swatch')
    swatchItems.forEach(function (s) {
      if (s === swatch) {
        s.setAttribute('data-active', 'true')
      } else {
        s.setAttribute('data-active', 'false')
      }
    })

    const parentRelative = swatch.closest('.relative')
    const h3Link = parentRelative.querySelector('h3 > a')
    const firstImage = parentRelative.querySelector('img')

    // Get the active swatch element
    const activeSwatch = parentRelative.querySelector(
      ".swatch[data-active='true']"
    )
    if (!activeSwatch) return

    const variantImg = activeSwatch.getAttribute('data-variant-img')
    const variantImgSrcset = activeSwatch.getAttribute(
      'data-variant-img-srcset'
    )
    const variantUrl = activeSwatch.getAttribute('data-variant-url')
    const productId = activeSwatch.getAttribute('data-product-id')

    if (variantImg) {
      firstImage.src = variantImg
      firstImage.srcset = variantImgSrcset
    }

    h3Link.setAttribute('href', variantUrl)

    const plusHref = document.querySelector('.product-variant-id-' + productId)
    if (plusHref) {
      plusHref.setAttribute('href', variantUrl)
    }

    const baseImg = document.querySelector(
      '.card-product-base-img-' + productId
    )
    if (baseImg) {
      baseImg.setAttribute('href', variantUrl)
    }
  }

  function handleSwatchClick(event) {
    const swatch = event.target.closest('.swatch')
    if (swatch) {
      toggleActiveAttributeAndChangeImageSrc(swatch)
    }
  }

  // Attach event listeners to the document for event delegation
  document.addEventListener('click', handleSwatchClick)
  document.addEventListener('mouseover', handleSwatchClick)
})
